import nikeMilerGris from "@/assets/products/nike-miler-gris.webp";
import nikeMilerRose from "@/assets/products/nike-miler-rose.webp";
import nikeMilerNoir from "@/assets/products/nike-miler-noir.webp";
import nikeMilerBleuMarine from "@/assets/products/nike-miler-bleu-marine.webp";
import nikeMilerBleuClair from "@/assets/products/nike-miler-bleu-clair.webp";
import uaPantalon from "@/assets/products/under-armour-pantalon.webp";
import uaHaut from "@/assets/products/under-armour-haut.avif";
import nikeDivisionBas from "@/assets/products/nike-division-bas.webp";
import nikeDivisionHaut from "@/assets/products/nike-division-haut.jpg";
import nikeTechNoir from "@/assets/products/nike-tech-noir.webp";
import nikeTechGris from "@/assets/products/nike-tech-gris.webp";
import nikeTnNoir from "@/assets/products/nike-tn-noir.webp";
import nikeTnBlanc from "@/assets/products/nike-tn-blanc.webp";
import nikeAeroswiftPant from "@/assets/products/nike-aeroswift-pant.webp";
import asicsNycBleu from "@/assets/products/asics-nyc-bleu.webp";
import asicsNycGris from "@/assets/products/asics-nyc-gris.webp";
import asicsNycNoir from "@/assets/products/asics-nyc-noir.webp";
import lvSkateBeige from "@/assets/products/lv-skate-beige.avif";
import poloRlZip1 from "@/assets/products/polo-rl-zip-1.avif";
import poloRlZip2 from "@/assets/products/polo-rl-zip-2.avif";
import poloRlZip3 from "@/assets/products/polo-rl-zip-3.avif";
import poloRlZip4 from "@/assets/products/polo-rl-zip-4.avif";
import lvSpeedy1 from "@/assets/products/lv-speedy-1.avif";
import lvSpeedy2 from "@/assets/products/lv-speedy-2.avif";
import lvSpeedy3 from "@/assets/products/lv-speedy-3.avif";
import lvSpeedy25Damier1 from "@/assets/products/lv-speedy-25-damier-1.avif";
import lvSpeedy25Damier2 from "@/assets/products/lv-speedy-25-damier-2.avif";
import lvSpeedy25Damier3 from "@/assets/products/lv-speedy-25-damier-3.avif";
import lvSpeedy25Damier4 from "@/assets/products/lv-speedy-25-damier-4.avif";
import lvSpeedy25Blanc from "@/assets/products/lv-speedy-25-blanc.avif";
import lvTmSpeedy25 from "@/assets/products/lv-tm-speedy-25.webp";
import diorLettera1 from "@/assets/products/dior-lettera-1.webp";
import diorLettera2 from "@/assets/products/dior-lettera-2.webp";
import diorSacocheHomme from "@/assets/products/dior-sacoche-homme.jpg";
import diorSacocheHomme2 from "@/assets/products/dior-sacoche-homme-2.webp";
import stoneIslandRose from "@/assets/products/stone-island-rose.jpg";
import stoneIslandBleu from "@/assets/products/stone-island-bleu.jpg";
import stoneIslandNoir from "@/assets/products/stone-island-noir.jpg";
import stoneIslandBlanc from "@/assets/products/stone-island-blanc.jpg";
import rlPolo from "@/assets/products/rl-polo.avif";
import rlTshirt from "@/assets/products/rl-tshirt.avif";
import rlTshirtFilleBlanc from "@/assets/products/rl-tshirt-fille-blanc.jpg";
import pullAiles1 from "@/assets/products/pull-ailes-1.avif";
import pullAiles2 from "@/assets/products/pull-ailes-2.avif";
import pullAiles3 from "@/assets/products/pull-ailes-3.avif";
import gertrudeNoir from "@/assets/products/gertrude-noir.webp";
import sweetpantsCap1 from "@/assets/products/sweetpants-cap-1.webp";
import sweetpantsCap2 from "@/assets/products/sweetpants-cap-2.webp";
import goldenGooseSuperstar1 from "@/assets/products/golden-goose-superstar-1.jpg";
import goldenGooseGoldStar from "@/assets/golden-goose-gold-star.webp";
import goldenGooseNavySilver from "@/assets/golden-goose-navy-silver.webp";
import goldenGooseKeepDoing from "@/assets/golden-goose-keep-doing.webp";
import goldenGooseBlackSuede from "@/assets/golden-goose-black-suede.webp";
import gucciCapBlack from "@/assets/gucci-cap-black.webp";
import gucciCapWhite from "@/assets/gucci-cap-white.webp";
import gucciCapBeige from "@/assets/gucci-cap-beige.webp";
import cartierLunettesRimless from "@/assets/products/prada-lunettes-rimless.webp";
import bapeTshirtNoir from "@/assets/products/bape-tshirt-noir.webp";
import casablancaTshirtNoir from "@/assets/products/casablanca-tshirt-noir.webp";
import casablancaTshirtBlanc from "@/assets/products/casablanca-tshirt-blanc.webp";
import goyardSaintSulpiceNoir from "@/assets/products/goyard-saint-sulpice-noir.webp";
import goyardSaintSulpiceBlanc from "@/assets/products/goyard-saint-sulpice-blanc.webp";
import nikeMind001Noir from "@/assets/products/nike-mind-001-noir.webp";
import burberryShortCheck from "@/assets/products/burberry-short-check.webp";
import nikeEnsembleBlancNoir from "@/assets/products/nike-ensemble-blanc-noir.webp";
import nikeEnsembleNoirBlanc from "@/assets/products/nike-ensemble-noir-blanc.webp";
import sauconyMulticolor from "@/assets/products/saucony-multicolor.webp";
import sauconyPink from "@/assets/products/saucony-pink.webp";
import corteizDenimShortsGrey from "@/assets/products/corteiz-denim-shorts-grey.webp";
import pandoraHeartRingRed from "@/assets/products/pandora-heart-ring-red.webp";
import lacosteBracelet from "@/assets/products/lacoste-bracelet.webp";
import necklaceHeartPink from "@/assets/products/necklace-heart-pink.webp";
import zadigRockWhite from "@/assets/products/zadig-rock-white.webp";
import zadigRockNavy from "@/assets/products/zadig-rock-navy.webp";
import zadigRockBeige from "@/assets/products/zadig-rock-beige.webp";
import zadigRockBlack from "@/assets/products/zadig-rock-black.webp";
import appleAirpods3 from "@/assets/apple-airpods-3.jpg";
import chromeHeartsHorseshoe from "@/assets/chrome-hearts-horseshoe.webp";
import jblFlip6Noir from "@/assets/jbl-flip-6-noir.jpg";
import jblFlip6Rouge from "@/assets/jbl-flip-6-rouge.webp";

export interface ProductVariant {
  name: string;
  options: string[];
}

export type Gender = "homme" | "femme" | "unisexe";

export interface Product {
  id: string;
  name: string;
  slug: string;
  price: number;
  originalPrice?: number;
  description: string;
  shortDescription: string;
  image: string;
  images?: string[];
  video?: string;
  category: string;
  gender: Gender;
  badge?: "bestseller" | "new" | "bundle";
  features: string[];
  compatibleWith: string[];
  inStock: boolean;
  variants?: ProductVariant[];
}

export const products: Product[] = [
  {
    id: "nike-miler",
    name: "Nike Miler",
    slug: "nike-miler",
    price: 45,
    originalPrice: 24,
    description: "T-shirt Nike Miler en tissu Dri-FIT respirant. Coupe moderne ajustée, détails réfléchissants, idéal pour la course comme pour le quotidien. Disponible en 5 coloris.",
    shortDescription: "T-shirt Nike Miler — Dri-FIT",
    image: nikeMilerNoir,
    images: [nikeMilerNoir, nikeMilerGris, nikeMilerRose, nikeMilerBleuMarine, nikeMilerBleuClair],
    category: "tshirts",
    gender: "unisexe",
    features: [
      "Technologie Dri-FIT",
      "Tissu respirant et léger",
      "Coupe moderne ajustée",
      "Détails réfléchissants",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [
      { name: "Couleur", options: ["Noir", "Gris", "Rose", "Bleu Marine", "Bleu Clair"] },
      { name: "Taille", options: ["S", "M", "L"] },
    ],
  },
  {
    id: "under-armour-pantalon",
    name: "Under Armour — Pantalon",
    slug: "under-armour-pantalon",
    price: 40,
    originalPrice: 55,
    description: "Pantalon Under Armour en tissu technique léger et respirant. Coupe ajustée, poches latérales, bas resserré. Confort optimal pour le sport et le quotidien.",
    shortDescription: "Pantalon Under Armour technique",
    image: uaPantalon,
    images: [uaPantalon],
    category: "pantalons",
    gender: "unisexe",    features: [
      "Tissu technique respirant",
      "Coupe ajustée moderne",
      "Bas resserré (jogger)",
      "Logo Under Armour brodé",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [{ name: "Taille", options: ["S", "M", "L"] }],
  },
  {
    id: "under-armour-haut",
    name: "Under Armour — Haut",
    slug: "under-armour-haut",
    price: 45,
    originalPrice: 80,
    description: "Haut Under Armour technique, coupe athlétique et tissu performant. Idéal pour l'entraînement comme pour un look streetwear sportif.",
    shortDescription: "Haut Under Armour technique",
    image: uaHaut,
    images: [uaHaut],
    category: "tshirts",
    gender: "homme",    badge: "new",
    features: [
      "Tissu technique performant",
      "Coupe athlétique",
      "Confort longue durée",
      "Logo Under Armour",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [{ name: "Taille", options: ["S", "M", "L"] }],
  },
  {
    id: "nike-division-bas",
    name: "Nike Run Division — Bas",
    slug: "nike-division-bas",
    price: 40,
    originalPrice: 55,
    description: "Pantalon de running Nike Run Division en tissu léger et stretch. Coupe fuselée, taille élastique, finitions haut de gamme. Conçu pour la performance et le style urbain.",
    shortDescription: "Pantalon Nike Run Division",
    image: nikeDivisionBas,
    images: [nikeDivisionBas],
    category: "pantalons",
    gender: "homme",    features: [
      "Tissu léger et stretch",
      "Coupe fuselée moderne",
      "Taille élastique confort",
      "Logo Swoosh discret",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [{ name: "Taille", options: ["S", "M", "L"] }],
  },
  {
    id: "nike-division-haut",
    name: "Nike Run Division — Haut",
    slug: "nike-division-haut",
    price: 45,
    originalPrice: 60,
    description: "Haut Nike Run Division demi-zip en coloris vert menthe. Tissu technique respirant, détails graphiques sur les manches, finitions réfléchissantes. Idéal pour le running et le streetwear.",
    shortDescription: "Haut Nike Run Division — Vert menthe",
    image: nikeDivisionHaut,
    images: [nikeDivisionHaut],
    category: "tshirts",
    gender: "unisexe",    badge: "new",
    features: [
      "Demi-zip technique",
      "Tissu respirant performant",
      "Détails réfléchissants",
      "Graphiques Run Division",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [{ name: "Taille", options: ["S", "M", "L"] }],
  },
  {
    id: "nike-tech-fleece",
    name: "Nike Tech Fleece — Veste à capuche",
    slug: "nike-tech-fleece",
    price: 45,
    originalPrice: 70,
    description: "Veste Nike Tech Fleece à capuche zippée. Tissu Tech Fleece premium chaud et léger, coupe ajustée, poche zippée sur la manche. L'icône streetwear par excellence. Disponible en Noir et Gris.",
    shortDescription: "Veste Nike Tech Fleece zippée",
    image: nikeTechNoir,
    images: [nikeTechNoir, nikeTechGris],
    category: "pulls",
    gender: "unisexe",
    features: [
      "Tissu Tech Fleece premium",
      "Capuche ajustable zippée",
      "Poche zippée sur la manche",
      "Coupe moderne ajustée",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [
      { name: "Couleur", options: ["Noir", "Gris"] },
      { name: "Taille", options: ["S", "M", "L"] },
    ],
  },
  {
    id: "nike-aeroswift-pant",
    name: "Nike AeroSwift — Pantalon Running",
    slug: "nike-aeroswift-pant",
    price: 40,
    originalPrice: 55,
    description: "Pantalon Nike AeroSwift Dri-FIT ADV. Tissu ultra-léger, coupe fuselée, cordon de serrage à la taille, zips aux chevilles. Pensé pour la course de haut niveau.",
    shortDescription: "Pantalon running Nike AeroSwift",
    image: nikeAeroswiftPant,
    images: [nikeAeroswiftPant],
    category: "pantalons",
    gender: "unisexe",    badge: "new",
    features: [
      "Technologie Dri-FIT ADV",
      "Tissu ultra-léger",
      "Coupe fuselée running",
      "Zips aux chevilles",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [{ name: "Taille", options: ["S", "M", "L"] }],
  },
  {
    id: "nike-tn",
    name: "Nike Air Max Plus TN",
    slug: "nike-tn",
    price: 50,
    originalPrice: 75,
    description: "L'iconique Nike Air Max Plus « TN ». Silhouette légendaire, unité Air visible, design futuriste. Disponible en Noir total et Blanc triple.",
    shortDescription: "Nike Air Max Plus TN",
    image: nikeTnNoir,
    images: [nikeTnNoir, nikeTnBlanc],
    category: "chaussures",
    gender: "unisexe",
    features: [
      "Unité Air Max visible",
      "Tige mesh respirante",
      "Design TN iconique",
      "Amorti longue durée",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [
      { name: "Couleur", options: ["Noir", "Blanc"] },
      { name: "Pointure", options: ["36", "37", "38", "39", "40", "41", "42", "43", "44", "45"] },
    ],
  },
  {
    id: "asics-gel-nyc",
    name: "Asics Gel-NYC",
    slug: "asics-gel-nyc",
    price: 50,
    originalPrice: 85,
    description: "Asics Gel-NYC, fusion des silhouettes GEL-NIMBUS 3 et GEL-MC PLUS. Look running rétro inspiré du début des années 2000, amorti GEL au talon, tige en mesh et daim premium. Disponible en 3 coloris.",
    shortDescription: "Asics Gel-NYC — sneaker rétro running",
    image: asicsNycGris,
    images: [asicsNycGris, asicsNycBleu, asicsNycNoir],
    category: "chaussures",
    gender: "homme",    badge: "new",
    features: [
      "Amorti GEL au talon",
      "Tige mesh & daim premium",
      "Silhouette rétro running",
      "Confort longue durée",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [
      { name: "Couleur", options: ["Gris", "Bleu Ciel", "Noir"] },
      { name: "Pointure", options: ["36", "37", "38", "39", "40", "41", "42", "43", "44", "45"] },
    ],
  },
  {
    id: "lv-skate-sneaker",
    name: "Louis Vuitton LV Skate Sneaker",
    slug: "lv-skate-sneaker",
    price: 50,
    originalPrice: 110,
    description: "La LV Skate Sneaker emblématique de Louis Vuitton. Silhouette skate luxueuse en cuir et daim beige & blanc, semelle épaisse signature, monogramme LV en relief. Pièce statement absolue.",
    shortDescription: "Louis Vuitton LV Skate — Beige & Blanc",
    image: lvSkateBeige,
    images: [lvSkateBeige],
    category: "chaussures",
    gender: "unisexe",    badge: "bestseller",
    features: [
      "Cuir & daim premium",
      "Semelle skate épaisse signature",
      "Monogramme LV en relief",
      "Made in Italy",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [
      { name: "Pointure", options: ["36", "37", "38", "39", "40", "41", "42", "43", "44", "45"] },
    ],
  },
  {
    id: "polo-ralph-lauren-zip",
    name: "Polo Ralph Lauren — Pull Zippé",
    slug: "polo-ralph-lauren-zip",
    price: 45,
    originalPrice: 80,
    description: "Pull zippé Polo Ralph Lauren. Maille premium, coupe régulière intemporelle, broderie iconique du Polo Player. L'élégance casual signature Ralph Lauren.",
    shortDescription: "Pull zippé Polo Ralph Lauren",
    image: poloRlZip1,
    images: [poloRlZip1, poloRlZip2, poloRlZip3, poloRlZip4],
    category: "pulls",
    gender: "homme",    badge: "new",
    features: [
      "Maille premium douce",
      "Coupe régulière intemporelle",
      "Broderie Polo Player iconique",
      "Zip métal qualité supérieure",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [
      { name: "Couleur", options: ["Bleu Marine", "Blanc", "Noir", "Gris"] },
      { name: "Taille", options: ["S", "M", "L"] },
    ],
  },
  {
    id: "lv-speedy-bandouliere-20",
    name: "Louis Vuitton Speedy Bandoulière 20",
    slug: "lv-speedy-bandouliere-20",
    price: 70,
    originalPrice: 140,
    description: "Le mythique Louis Vuitton Speedy Bandoulière 20 en toile Monogram marron. Format compact ultra-tendance, anses cuir, bandoulière amovible, intérieur spacieux. L'icône absolue de la maison LV.",
    shortDescription: "Sac LV Speedy Bandoulière 20 — Monogram",
    image: lvSpeedy1,
    images: [lvSpeedy1, lvSpeedy2, lvSpeedy3],
    category: "sacs-a-main",
    gender: "homme",    badge: "bestseller",
    features: [
      "Toile Monogram iconique",
      "Anses et finitions cuir",
      "Bandoulière amovible & ajustable",
      "Made in France",
    ],
    compatibleWith: [],
    inStock: true,
  },
  {
    id: "lv-speedy-bandouliere-25-damier",
    name: "Louis Vuitton Speedy Bandoulière 25 — Damier Ebene",
    slug: "lv-speedy-bandouliere-25-damier-ebene",
    price: 95,
    originalPrice: 180,
    description: "Le légendaire Louis Vuitton Speedy Bandoulière 25 en toile Damier Ebene marron doré. Format polyvalent, anses et finitions cuir naturel, bandoulière amovible et ajustable. L'élégance intemporelle d'une icône de la maison Louis Vuitton.",
    shortDescription: "Sac LV Speedy Bandoulière 25 — Damier Ebene",
    image: lvSpeedy25Damier2,
    images: [lvSpeedy25Damier2, lvSpeedy25Damier3, lvSpeedy25Damier4],
    category: "sacs-a-main",
    gender: "femme",
    badge: "new",
    features: [
      "Toile Damier Ebene iconique",
      "Anses et finitions cuir naturel",
      "Bandoulière amovible & ajustable",
      "Cadenas et clochette en laiton doré",
      "Made in France",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [
      { name: "Taille", options: ["16 cm", "20 cm", "25 cm", "30 cm"] },
    ],
  },
  {
    id: "lv-speedy-bandouliere-25-blanc",
    name: "Louis Vuitton Speedy Bandoulière 25 — Blanc",
    slug: "lv-speedy-bandouliere-25-blanc",
    price: 95,
    originalPrice: 180,
    description: "Le légendaire Louis Vuitton Speedy Bandoulière 25 dans sa version blanche immaculée. Toile élégante, anses et finitions cuir naturel, bandoulière amovible et ajustable. Une pièce raffinée pour un look lumineux et intemporel.",
    shortDescription: "Sac LV Speedy Bandoulière 25 — Blanc",
    image: lvSpeedy25Blanc,
    images: [lvSpeedy25Blanc],
    category: "sacs-a-main",
    gender: "femme",
    badge: "new",
    features: [
      "Toile blanche élégante",
      "Anses et finitions cuir naturel",
      "Bandoulière amovible & ajustable",
      "Cadenas et clochette en laiton doré",
      "Made in France",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [
      { name: "Taille", options: ["16 cm", "20 cm", "25 cm", "30 cm"] },
    ],
  },
  {
    id: "lv-x-tm-speedy-bandouliere-25",
    name: "LV x TM — Sac Speedy Bandoulière 25",
    slug: "lv-x-tm-speedy-bandouliere-25",
    price: 70,
    originalPrice: 160,
    description: "Édition collaborative LV x TM. Le célèbre Speedy Bandoulière 25 revisité dans une version exclusive, mêlant l'iconique monogramme Louis Vuitton à l'univers artistique de Takashi Murakami. Pièce de collection, anses et finitions cuir, bandoulière amovible.",
    shortDescription: "LV x TM Speedy Bandoulière 25 — édition collab",
    image: lvTmSpeedy25,
    images: [lvTmSpeedy25],
    category: "sacs-a-main",
    gender: "femme",
    badge: "new",
    features: [
      "Édition collaborative LV x TM",
      "Format Speedy 25 iconique",
      "Anses et finitions cuir",
      "Bandoulière amovible & ajustable",
      "Pièce de collection",
    ],
    compatibleWith: [],
    inStock: true,
  },
  {
    id: "dior-lettera-25",
    name: "Dior Lettera 25",
    slug: "dior-lettera-25",
    price: 70,
    originalPrice: 140,
    description: "Sac Dior Lettera 25 en cuir matelassé noir façon cannage. Anse à chaîne argentée tressée, fermeture par cordon de serrage, format épaule moderne. Élégance contemporaine signature Dior.",
    shortDescription: "Sac Dior Lettera 25 — cuir matelassé noir",
    image: diorLettera1,
    images: [diorLettera1, diorLettera2],
    category: "sacs-a-main",
    gender: "femme",    badge: "bestseller",
    features: [
      "Cuir matelassé façon cannage",
      "Anse chaîne argentée tressée cuir",
      "Fermeture cordon de serrage",
      "Format épaule contemporain",
    ],
    compatibleWith: [],
    inStock: true,
  },
  {
    id: "stone-island-crewneck",
    name: "Stone Island — Pull Crewneck",
    slug: "stone-island-crewneck",
    price: 45,
    originalPrice: 55,
    description: "Pull Stone Island col rond, modèle iconique mixte homme/femme. Maille premium douce, badge boussole signature amovible sur la manche. Disponible en 4 coloris : Rose pastel, Bleu ciel, Noir et Blanc.",
    shortDescription: "Pull Stone Island col rond — 4 coloris",
    image: stoneIslandNoir,
    images: [stoneIslandNoir, stoneIslandBlanc, stoneIslandBleu, stoneIslandRose],
    category: "pulls",
    gender: "femme",
    features: [
      "Maille premium douce",
      "Badge boussole iconique amovible",
      "Coupe régulière mixte",
      "Made in Italy",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [
      { name: "Couleur", options: ["Noir", "Blanc", "Bleu Ciel", "Rose"] },
      { name: "Taille", options: ["S", "M", "L", "XL"] },
    ],
  },
  {
    id: "dior-sacoche-homme-oblique",
    name: "Dior Sacoche Homme — Oblique",
    slug: "dior-sacoche-homme-oblique",
    price: 50,
    originalPrice: 110,
    description: "Sacoche bandoulière Dior Homme en toile Oblique noire. Format compact urbain, bandoulière ajustable, finitions cuir noir, signature DIOR métal. L'essentiel maroquinerie homme.",
    shortDescription: "Sacoche Dior Homme — toile Oblique noire",
    image: diorSacocheHomme,
    images: [diorSacocheHomme, diorSacocheHomme2],
    category: "sacoches",
    gender: "unisexe",    badge: "bestseller",
    features: [
      "Toile Oblique iconique noire",
      "Bandoulière ajustable",
      "Finitions cuir & métal",
      "Format crossbody urbain",
    ],
    compatibleWith: [],
    inStock: true,
  },
  {
    id: "ralph-lauren-polo",
    name: "Ralph Lauren — Polo Classique",
    slug: "ralph-lauren-polo",
    price: 45,
    originalPrice: 45,
    description: "Le polo iconique Ralph Lauren en piqué de coton. Coupe régulière intemporelle, col côtelé, broderie Polo Player signature sur la poitrine. L'élégance casual par excellence.",
    shortDescription: "Polo Ralph Lauren — piqué de coton",
    image: rlPolo,
    images: [rlPolo],
    category: "tshirts",
    gender: "homme",    badge: "bestseller",
    features: [
      "Piqué de coton premium",
      "Coupe régulière intemporelle",
      "Broderie Polo Player iconique",
      "Col et manches côtelés",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [{ name: "Taille", options: ["S", "M", "L", "XL"] }],
  },
  {
    id: "ralph-lauren-tshirt",
    name: "Ralph Lauren — T-Shirt",
    slug: "ralph-lauren-tshirt",
    price: 45,
    originalPrice: 45,
    description: "T-shirt Ralph Lauren en jersey de coton doux. Coupe classique, encolure ronde côtelée, broderie Polo Player iconique. L'essentiel intemporel du dressing.",
    shortDescription: "T-shirt Ralph Lauren — jersey coton",
    image: rlTshirt,
    images: [rlTshirt],
    category: "tshirts",
    gender: "homme",    badge: "new",
    features: [
      "Jersey de coton doux",
      "Coupe classique confort",
      "Broderie Polo Player iconique",
      "Encolure côtelée",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [{ name: "Taille", options: ["S", "M", "L", "XL"] }],
  },
  {
    id: "ralph-lauren-tshirt-fille-blanc",
    name: "Ralph Lauren — T-Shirt Fille Blanc",
    slug: "ralph-lauren-tshirt-fille-blanc",
    price: 35,
    originalPrice: 45,
    description: "T-shirt Ralph Lauren pour fille en jersey de coton doux blanc. Manches courtes, encolure ronde côtelée, broderie Polo Player iconique en bleu marine. L'essentiel intemporel du dressing junior.",
    shortDescription: "T-shirt Ralph Lauren Fille — Blanc",
    image: rlTshirtFilleBlanc,
    images: [rlTshirtFilleBlanc],
    category: "tshirts",
    gender: "femme",
    badge: "new",
    features: [
      "Jersey de coton doux",
      "Manches courtes",
      "Broderie Polo Player iconique",
      "Encolure ronde côtelée",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [{ name: "Taille", options: ["6 ans", "8 ans", "10 ans", "12 ans", "14 ans", "16 ans"] }],
  },
  {
    id: "pull-ailes-ange",
    name: "Pull Ailes d'Ange",
    slug: "pull-ailes-ange",
    price: 45,
    originalPrice: 50,
    description: "Pull tendance avec broderie d'ailes d'ange dans le dos. Maille premium douce, coupe oversize streetwear, finitions soignées. Disponible en Bleu Marine et Blanc.",
    shortDescription: "Pull Ailes d'Ange — broderie dos",
    image: pullAiles1,
    images: [pullAiles1, pullAiles2, pullAiles3],
    category: "pulls",
    gender: "homme",    badge: "new",
    features: [
      "Broderie ailes d'ange au dos",
      "Maille premium douce",
      "Coupe oversize streetwear",
      "Finitions soignées",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [
      { name: "Couleur", options: ["Bleu Marine", "Blanc"] },
      { name: "Taille", options: ["S", "M", "L", "XL"] },
    ],
  },
  {
    id: "casquette-gertrude",
    name: "Casquette Gertrude",
    slug: "casquette-gertrude",
    price: 30,
    originalPrice: 50,
    description: "Casquette Gertrude trucker au design signature. Façade structurée avec broderie ton sur ton, dos en mesh respirant, patch orange iconique sur le côté. Réglable à l'arrière. Coloris Noir total.",
    shortDescription: "Casquette Gertrude trucker — Noir",
    image: gertrudeNoir,
    images: [gertrudeNoir],
    category: "casquettes",
    gender: "unisexe",    badge: "new",
    features: [
      "Façade structurée brodée ton sur ton",
      "Dos mesh respirant",
      "Patch orange signature",
      "Fermeture réglable arrière",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [
      { name: "Couleur", options: ["Noir"] },
    ],
  },
  {
    id: "sweet-pants-home-run-cap",
    name: "Sweet Pants — Home Run Cap",
    slug: "sweet-pants-home-run-cap",
    price: 30,
    originalPrice: 50,
    description: "Casquette Sweet Pants Home Run, modèle trucker vintage. Façade écrue avec patch brodé signature « Sweet Pants Since 1982 », visière noire effet usé délavé, dos en mesh noir respirant. Esprit americana authentique.",
    shortDescription: "Casquette Sweet Pants Home Run — trucker vintage",
    image: sweetpantsCap1,
    images: [sweetpantsCap1, sweetpantsCap2],
    category: "casquettes",
    gender: "femme",    badge: "new",
    features: [
      "Patch brodé Sweet Pants signature",
      "Visière effet usé vintage",
      "Dos mesh respirant",
      "Fermeture réglable arrière",
    ],
    compatibleWith: [],
    inStock: true,
  },
  {
    id: "casquette-gucci-gg-noir",
    name: "Casquette Gucci GG Canvas — Noir",
    slug: "casquette-gucci-gg-noir",
    price: 30,
    originalPrice: 50,
    description: "Casquette Gucci en toile GG Supreme noire, monogramme signature en relief ton sur ton. Visière courbée, fermeture réglable à l'arrière. Pièce iconique de la maison italienne.",
    shortDescription: "Casquette Gucci GG Canvas — Noir",
    image: gucciCapBlack,
    images: [gucciCapBlack],
    category: "casquettes",
    gender: "unisexe",
    badge: "bestseller",
    features: [
      "Toile GG Supreme monogramme",
      "Visière courbée structurée",
      "Fermeture réglable arrière",
      "Signature Gucci",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [
      { name: "Couleur", options: ["Noir"] },
    ],
  },
  {
    id: "casquette-gucci-gg-blanc",
    name: "Casquette Gucci GG Canvas — Blanc Web",
    slug: "casquette-gucci-gg-blanc",
    price: 30,
    originalPrice: 50,
    description: "Casquette Gucci en toile GG Supreme blanche avec bande Web vert-rouge-vert signature sur le côté. Monogramme GG en relief, visière courbée, fermeture réglable. Esprit luxe italien.",
    shortDescription: "Casquette Gucci GG — Blanc bande Web",
    image: gucciCapWhite,
    images: [gucciCapWhite],
    category: "casquettes",
    gender: "unisexe",
    badge: "bestseller",
    features: [
      "Toile GG Supreme blanche",
      "Bande Web vert-rouge-vert iconique",
      "Visière courbée",
      "Fermeture réglable arrière",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [
      { name: "Couleur", options: ["Blanc"] },
    ],
  },
  {
    id: "casquette-gucci-gg-beige",
    name: "Casquette Gucci GG Canvas — Beige Web",
    slug: "casquette-gucci-gg-beige",
    price: 30,
    originalPrice: 50,
    description: "Casquette Gucci en toile GG Supreme beige original, monogramme GG marron iconique, bande Web vert-rouge-vert sur le côté. Visière courbée, fermeture réglable. Le classique intemporel de la maison.",
    shortDescription: "Casquette Gucci GG — Beige bande Web",
    image: gucciCapBeige,
    images: [gucciCapBeige],
    category: "casquettes",
    gender: "unisexe",
    badge: "bestseller",
    features: [
      "Toile GG Supreme beige originale",
      "Bande Web vert-rouge-vert signature",
      "Monogramme GG marron",
      "Fermeture réglable arrière",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [
      { name: "Couleur", options: ["Beige"] },
    ],
  },
  {
    id: "golden-goose-superstar",
    name: "Golden Goose Superstar Low White Leopard Star Glitter",
    slug: "golden-goose-superstar",
    price: 50,
    originalPrice: 165,
    description: "Sneakers Golden Goose Super-Star Low en cuir et toile blanche, étoile signature en poulain léopard, talon doré métallisé, paillettes argentées sur le côté. Effet vintage usé iconique, semelle distressed signature. Made in Italy.",
    shortDescription: "Golden Goose Super-Star — étoile léopard",
    image: goldenGooseSuperstar1,
    images: [goldenGooseSuperstar1],
    category: "chaussures",
    gender: "femme",
    badge: "bestseller",
    features: [
      "Cuir et toile premium",
      "Étoile en poulain effet léopard",
      "Talon doré métallisé & paillettes",
      "Effet vintage distressed signature",
      "Made in Italy",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [
      { name: "Pointure", options: ["36", "37", "38", "39", "40", "41", "42", "43", "44", "45"] },
    ],
  },
  {
    id: "golden-goose-superstar-gold-star",
    name: "Golden Goose Superstar — Étoile Or & Talon Glitter Noir",
    slug: "golden-goose-superstar-gold-star",
    price: 50,
    originalPrice: 165,
    description: "Sneakers Golden Goose Super-Star Low en cuir blanc, étoile signature en glitter doré, talon en glitter noir contrastant. Effet vintage usé iconique, semelle distressed signature. Made in Italy.",
    shortDescription: "Golden Goose Super-Star — étoile or / talon noir glitter",
    image: goldenGooseGoldStar,
    images: [goldenGooseGoldStar],
    category: "chaussures",
    gender: "femme",
    badge: "bestseller",
    features: [
      "Cuir blanc premium",
      "Étoile glitter doré",
      "Talon glitter noir",
      "Effet vintage distressed",
      "Made in Italy",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [
      { name: "Pointure", options: ["36", "37", "38", "39", "40", "41", "42", "43", "44", "45"] },
    ],
  },
  {
    id: "golden-goose-superstar-navy-silver",
    name: "Golden Goose Superstar — Étoile Argent & Talon Bleu Nuit",
    slug: "golden-goose-superstar-navy-silver",
    price: 50,
    originalPrice: 165,
    description: "Sneakers Golden Goose Super-Star Low en cuir blanc, étoile signature en glitter argenté, talon en glitter bleu nuit. Effet vintage usé iconique, semelle distressed signature. Made in Italy.",
    shortDescription: "Golden Goose Super-Star — étoile argent / talon bleu nuit",
    image: goldenGooseNavySilver,
    images: [goldenGooseNavySilver],
    category: "chaussures",
    gender: "femme",
    badge: "bestseller",
    features: [
      "Cuir blanc premium",
      "Étoile glitter argentée",
      "Talon glitter bleu nuit",
      "Effet vintage distressed",
      "Made in Italy",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [
      { name: "Pointure", options: ["36", "37", "38", "39", "40", "41", "42", "43", "44", "45"] },
    ],
  },
  {
    id: "golden-goose-superstar-keep-doing",
    name: "Golden Goose Superstar — Beige 'Keep Doing What You Love'",
    slug: "golden-goose-superstar-keep-doing",
    price: 50,
    originalPrice: 165,
    description: "Sneakers Golden Goose Super-Star Low en cuir blanc avec talon beige suédé, étoile glitter argenté et lacets roses. Inscription manuscrite signature 'Keep Doing What You Love' sur la semelle. Effet vintage usé, made in Italy.",
    shortDescription: "Golden Goose Super-Star — beige / lacets roses / message",
    image: goldenGooseKeepDoing,
    images: [goldenGooseKeepDoing],
    category: "chaussures",
    gender: "femme",
    badge: "bestseller",
    features: [
      "Cuir blanc & talon beige suédé",
      "Étoile glitter argentée",
      "Lacets roses contrastants",
      "Inscription 'Keep Doing What You Love'",
      "Made in Italy",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [
      { name: "Pointure", options: ["36", "37", "38", "39", "40", "41", "42", "43", "44", "45"] },
    ],
  },
  {
    id: "golden-goose-superstar-black-suede",
    name: "Golden Goose Superstar — Étoile Suédée & Talon Noir",
    slug: "golden-goose-superstar-black-suede",
    price: 50,
    originalPrice: 165,
    description: "Sneakers Golden Goose Super-Star Low en cuir blanc, étoile signature en suède gris taupe, talon en cuir noir contrastant. Effet vintage usé iconique, semelle distressed signature. Made in Italy.",
    shortDescription: "Golden Goose Super-Star — étoile suède / talon noir",
    image: goldenGooseBlackSuede,
    images: [goldenGooseBlackSuede],
    category: "chaussures",
    gender: "unisexe",
    badge: "bestseller",
    features: [
      "Cuir blanc premium",
      "Étoile suède gris taupe",
      "Talon cuir noir",
      "Effet vintage distressed",
      "Made in Italy",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [
      { name: "Pointure", options: ["36", "37", "38", "39", "40", "41", "42", "43", "44", "45"] },
    ],
  },
  {
    id: "cartier-lunettes-rimless",
    name: "Cartier — Lunettes Rimless Or",
    slug: "cartier-lunettes-rimless",
    price: 20,
    originalPrice: 65,
    description: "Lunettes de soleil Cartier sans monture (rimless), verres rectangulaires fumés et branches dorées signature. Élégance contemporaine et finition haut de gamme. Livrées avec étui rouge iconique.",
    shortDescription: "Lunettes Cartier Rimless — verres fumés / branches or",
    image: cartierLunettesRimless,
    images: [cartierLunettesRimless],
    category: "lunettes",
    gender: "unisexe",
    badge: "bestseller",
    features: [
      "Monture rimless (sans cadre)",
      "Verres rectangulaires fumés",
      "Branches dorées signature Cartier",
      "Étui rouge premium inclus",
    ],
    compatibleWith: [],
    inStock: true,
  },
  {
    id: "bape-tshirt-noir",
    name: "BAPE — T-Shirt Ape Head Noir",
    slug: "bape-tshirt-noir",
    price: 45,
    originalPrice: 45,
    description: "T-shirt A Bathing Ape (BAPE) noir avec imprimé Ape Head iconique en outline blanc sur le devant et logo au dos. Coton premium, coupe régulière streetwear, finitions soignées. Pièce signature de la maison japonaise.",
    shortDescription: "T-shirt BAPE Ape Head — Noir",
    image: bapeTshirtNoir,
    images: [bapeTshirtNoir],
    category: "tshirts",
    gender: "unisexe",
    badge: "new",
    features: [
      "Coton premium 100%",
      "Imprimé Ape Head iconique",
      "Coupe régulière streetwear",
      "Logo BAPE signature au dos",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [
      { name: "Couleur", options: ["Noir"] },
      { name: "Taille", options: ["S", "M", "L", "XL"] },
    ],
  },
  {
    id: "casablanca-tshirt",
    name: "Casablanca — T-Shirt Imprimé",
    slug: "casablanca-tshirt",
    price: 45,
    originalPrice: 45,
    description: "T-shirt Casablanca Paris avec imprimé artistique signature au dos (palmiers, paysage urbain et lune). Coton premium, coupe oversize relaxée, esprit luxe contemporain. Disponible en Noir et Blanc.",
    shortDescription: "T-shirt Casablanca — imprimé signature",
    image: casablancaTshirtNoir,
    images: [casablancaTshirtNoir, casablancaTshirtBlanc],
    category: "tshirts",
    gender: "unisexe",
    badge: "bestseller",
    features: [
      "Coton premium 100%",
      "Imprimé artistique signature dos",
      "Coupe oversize relaxée",
      "Made in Portugal",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [
      { name: "Couleur", options: ["Noir", "Blanc"] },
      { name: "Taille", options: ["S", "M", "L", "XL"] },
    ],
  },
  {
    id: "goyard-saint-sulpice",
    name: "Goyard — Porte-cartes Saint-Sulpice",
    slug: "goyard-saint-sulpice",
    price: 25,
    originalPrice: 49,
    description: "Porte-cartes Goyard modèle Saint-Sulpice en toile Goyardine signature. Format compact ultra-plat, 4 emplacements cartes, cuir contrasté en bordure. L'accessoire iconique de la maison parisienne. Disponible en Noir et Blanc.",
    shortDescription: "Porte-cartes Goyard Saint-Sulpice — Goyardine",
    image: goyardSaintSulpiceNoir,
    images: [goyardSaintSulpiceNoir, goyardSaintSulpiceBlanc],
    category: "accessoires",
    gender: "unisexe",
    badge: "bestseller",
    features: [
      "Toile Goyardine iconique",
      "4 emplacements cartes",
      "Cuir contrasté premium",
      "Made in France",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [
      { name: "Couleur", options: ["Noir", "Blanc"] },
    ],
  },
  {
    id: "nike-mind-001-slide",
    name: "Nike Mind 001 Slide",
    slug: "nike-mind-001-slide",
    price: 50,
    originalPrice: 75,
    description: "Nike Mind 001 Slide en coloris noir total avec semelle orange contrastée. Mule sport innovante au design futuriste, perforations aérées, semelle technique pour un confort enveloppant. Pièce statement.",
    shortDescription: "Nike Mind 001 Slide — Noir / semelle orange",
    image: nikeMind001Noir,
    images: [nikeMind001Noir],
    category: "chaussures",
    gender: "unisexe",
    badge: "new",
    features: [
      "Design mule futuriste",
      "Perforations aérées",
      "Semelle technique orange",
      "Confort enveloppant",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [
      { name: "Pointure", options: ["36", "37", "38", "39", "40", "41", "42", "43", "44", "45"] },
    ],
  },
  {
    id: "burberry-short-check",
    name: "Burberry — Short Vintage Check",
    slug: "burberry-short-check",
    price: 30,
    originalPrice: 45,
    description: "Short Burberry en tissu léger imprimé Vintage Check iconique. Taille élastique avec cordon de serrage, coupe ample confortable. L'élégance British casual signature Burberry.",
    shortDescription: "Short Burberry — Vintage Check",
    image: burberryShortCheck,
    images: [burberryShortCheck],
    category: "shorts",
    gender: "homme",
    badge: "bestseller",
    features: [
      "Imprimé Vintage Check iconique",
      "Tissu léger respirant",
      "Taille élastique cordon",
      "Coupe ample confort",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [{ name: "Taille", options: ["S", "M", "L", "XL"] }],
  },
  {
    id: "nike-ensemble-tshirt-short",
    name: "Nike — Ensemble T-shirt + Short",
    slug: "nike-ensemble-tshirt-short",
    price: 45,
    originalPrice: 60,
    description: "Ensemble Nike t-shirt + short avec détails réfléchissants et logo Swoosh brodé. Tissu respirant Dri-FIT, parfait pour le sport ou le streetwear. Disponible en Blanc/Noir et Noir/Blanc.",
    shortDescription: "Ensemble Nike t-shirt + short — 2 coloris",
    image: nikeEnsembleBlancNoir,
    images: [nikeEnsembleBlancNoir, nikeEnsembleNoirBlanc],
    category: "tshirts",
    gender: "unisexe",
    badge: "bundle",
    features: [
      "T-shirt + short inclus",
      "Détails réfléchissants",
      "Logo Swoosh brodé",
      "Tissu respirant Dri-FIT",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [
      { name: "Couleur", options: ["Blanc / Noir", "Noir / Blanc"] },
      { name: "Taille", options: ["S", "M", "L", "XL"] },
    ],
  },
  {
    id: "saucony-progrid-omni",
    name: "Saucony ProGrid Omni — Sneaker Rétro",
    slug: "saucony-progrid-omni",
    price: 50,
    originalPrice: 80,
    description: "Sneaker Saucony ProGrid Omni au design rétro running début 2000s. Tige mesh respirante, amorti ProGrid premium, semelle multicolore vibrante. Disponible en multicolore (vert/orange/jaune) et rose pastel.",
    shortDescription: "Saucony ProGrid Omni — sneaker rétro",
    image: sauconyMulticolor,
    images: [sauconyMulticolor, sauconyPink],
    category: "chaussures",
    gender: "unisexe",
    badge: "new",
    features: [
      "Amorti ProGrid premium",
      "Tige mesh respirante",
      "Design rétro running 2000s",
      "Semelle multicolore vibrante",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [
      { name: "Couleur", options: ["Multicolore", "Rose"] },
      { name: "Pointure", options: ["36", "37", "38", "39", "40", "41", "42", "43", "44", "45"] },
    ],
  },
  {
    id: "corteiz-denim-shorts-star",
    name: "Corteiz — Denim Shorts Star Embroidery Grey",
    slug: "corteiz-denim-shorts-star",
    price: 50,
    originalPrice: 70,
    description: "Short en denim Corteiz coloris gris délavé avec broderies étoile et logo Alcatraz signature sur les poches arrières. Coupe baggy, denim épais qualité premium. Pièce streetwear collector.",
    shortDescription: "Corteiz Denim Shorts — Star Embroidery Grey",
    image: corteizDenimShortsGrey,
    images: [corteizDenimShortsGrey],
    category: "shorts",
    gender: "unisexe",
    badge: "new",
    features: [
      "Denim épais premium",
      "Broderies étoile & Alcatraz",
      "Coupe baggy streetwear",
      "Délavage gris vintage",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [{ name: "Taille", options: ["S", "M", "L", "XL"] }],
  },
  {
    id: "pandora-heart-ring-red",
    name: "Pandora Timeless Elevated Heart Ring",
    slug: "pandora-heart-ring-red",
    price: 25,
    originalPrice: 49,
    description: "Bague Pandora Timeless Elevated Heart en métal plaqué or 14k, ornée d'un cristal rouge en forme de cœur entouré d'un halo de pierres scintillantes. Élégance intemporelle pour toutes les occasions.",
    shortDescription: "Bague cœur cristal rouge — plaqué or 14k",
    image: pandoraHeartRingRed,
    images: [pandoraHeartRingRed],
    category: "accessoires",
    gender: "femme",
    badge: "new",
    features: [
      "Plaqué or 14 carats",
      "Cristal rouge taillé en cœur",
      "Halo de pierres scintillantes",
      "Signature Pandora gravée",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [{ name: "Taille", options: ["50", "52", "54", "56", "58"] }],
  },
  {
    id: "lacoste-bracelet",
    name: "Bracelet Lacoste",
    slug: "lacoste-bracelet",
    price: 25,
    originalPrice: 49,
    description: "Bracelet Lacoste en acier inoxydable poli avec maillons texturés et plaque centrale gravée du crocodile iconique. Pièce élégante et durable pour un style affirmé au quotidien.",
    shortDescription: "Bracelet Lacoste acier inoxydable",
    image: lacosteBracelet,
    images: [lacosteBracelet],
    category: "accessoires",
    gender: "homme",
    features: [
      "Acier inoxydable poli",
      "Maillons texturés design",
      "Logo crocodile gravé",
      "Fermoir sécurisé",
    ],
    compatibleWith: [],
    inStock: true,
  },
  {
    id: "necklace-heart-crystal-pink",
    name: "Collier Cœur Cristal Rose",
    slug: "necklace-heart-crystal-pink",
    price: 25,
    originalPrice: 49,
    description: "Collier délicat en métal doré rose avec pendentif cœur serti d'un cristal rose entouré d'un halo de pierres scintillantes. Une pièce romantique et élégante.",
    shortDescription: "Collier pendentif cœur cristal rose",
    image: necklaceHeartPink,
    images: [necklaceHeartPink],
    category: "accessoires",
    gender: "femme",
    badge: "new",
    features: [
      "Finition or rose",
      "Pendentif cœur cristal rose",
      "Halo de pierres scintillantes",
      "Chaîne fine ajustable",
    ],
    compatibleWith: [],
    inStock: true,
  },
  {
    id: "zadig-voltaire-rock",
    name: "Zadig & Voltaire — Sac Rock",
    slug: "zadig-voltaire-rock",
    price: 46,
    originalPrice: 95,
    description: "Iconique sac Rock de Zadig & Voltaire en cuir matelassé. Bandoulière chaîne amovible, fermeture éclair, emblème ailes signature serti de cristaux. Disponible en 4 coloris.",
    shortDescription: "Sac Rock matelassé — chaîne",
    image: zadigRockBlack,
    images: [zadigRockBlack, zadigRockWhite, zadigRockNavy, zadigRockBeige],
    category: "sacs-a-main",
    gender: "femme",
    badge: "new",
    features: [
      "Cuir matelassé premium",
      "Bandoulière chaîne amovible",
      "Emblème ailes serti de cristaux",
      "Fermeture éclair sécurisée",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [
      { name: "Couleur", options: ["Noir", "Blanc", "Bleu nuit", "Beige"] },
    ],
  },
  {
    id: "apple-airpods-3",
    name: "Apple AirPods 3e génération",
    slug: "apple-airpods-3",
    price: 30,
    originalPrice: 199,
    description: "Écouteurs sans fil Apple AirPods 3e génération. Audio spatial personnalisé, résistance à la sueur et à l'eau (IPX4), boîtier de charge MagSafe. Jusqu'à 6 heures d'écoute par charge, 30h avec le boîtier.",
    shortDescription: "Écouteurs sans fil — audio spatial",
    image: appleAirpods3,
    images: [appleAirpods3],
    category: "accessoires",
    gender: "unisexe",
    badge: "new",
    features: [
      "Audio spatial personnalisé",
      "Résistance à la sueur et à l'eau (IPX4)",
      "Boîtier de charge MagSafe",
      "Jusqu'à 30h d'autonomie avec le boîtier",
    ],
    compatibleWith: [],
    inStock: true,
  },
  {
    id: "chrome-hearts-horseshoe-tshirt",
    name: "Chrome Hearts — T-shirt Horseshoe",
    slug: "chrome-hearts-horseshoe-tshirt",
    price: 55,
    originalPrice: 420,
    description: "T-shirt Chrome Hearts noir avec imprimé Horseshoe iconique au dos en lettrage gothique blanc. Coton lourd premium, coupe oversize parfaite pour l'été. Petit logo Chrome Hearts à l'avant.",
    shortDescription: "T-shirt Horseshoe oversize — coton lourd",
    image: chromeHeartsHorseshoe,
    images: [chromeHeartsHorseshoe],
    category: "tshirts",
    gender: "unisexe",
    badge: "new",
    features: [
      "Coton lourd premium",
      "Coupe oversize",
      "Imprimé Horseshoe au dos",
      "Petit logo brodé devant",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [
      { name: "Taille", options: ["S", "M", "L", "XL"] },
    ],
  },
  {
    id: "jbl-flip-6",
    name: "JBL Flip 6 — Enceinte Bluetooth",
    slug: "jbl-flip-6",
    price: 40,
    originalPrice: 139,
    description: "Enceinte portable JBL Flip 6 avec son JBL Original Pro. Étanche IP67, autonomie 12h, basses puissantes et aigus cristallins. Connexion PartyBoost pour associer plusieurs enceintes. Disponible en noir et rouge.",
    shortDescription: "Enceinte Bluetooth — étanche IP67, 12h",
    image: jblFlip6Noir,
    images: [jblFlip6Noir, jblFlip6Rouge],
    category: "accessoires",
    gender: "unisexe",
    badge: "new",
    features: [
      "Son JBL Original Pro",
      "Étanche & antipoussière IP67",
      "Autonomie 12 heures",
      "PartyBoost pour multi-enceintes",
    ],
    compatibleWith: [],
    inStock: true,
    variants: [
      { name: "Couleur", options: ["Noir", "Rouge"] },
    ],
  },
];

export const categories = [
  { id: "all", label: "Tout" },
  { id: "tshirts", label: "T-Shirts" },
  { id: "pulls", label: "Pulls & Hoodies" },
  { id: "pantalons", label: "Pantalons" },
  { id: "shorts", label: "Shorts" },
  { id: "chaussures", label: "Chaussures" },
  { id: "sacs-a-main", label: "Sacs à main" },
  { id: "sacoches", label: "Sacoches" },
  { id: "casquettes", label: "Casquettes" },
  { id: "lunettes", label: "Lunettes" },
  { id: "accessoires", label: "Accessoires" },
];

export function getProductBySlug(slug: string): Product | undefined {
  return products.find((p) => p.slug === slug);
}

export function getProductById(id: string): Product | undefined {
  return products.find((p) => p.id === id);
}

export function getRelatedProducts(productId: string, limit = 3): Product[] {
  const product = getProductById(productId);
  if (!product) return products.slice(0, limit);
  const sameCat = products.filter((p) => p.id !== productId && p.category === product.category);
  return sameCat.length > 0 ? sameCat.slice(0, limit) : products.filter((p) => p.id !== productId).slice(0, limit);
}
